"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var hooks_1 = require("utils/hooks");
var intl_1 = require("utils/setectOptions/intl");
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var CountrySelect = function (_a) {
    var _b, _c;
    var item = _a.item;
    var _d = __read((0, hooks_1.useSubmitter)('recharged_customers', item.rechCustomerId), 2), submitCustomer = _d[0], isSending = _d[1];
    var val = intl_1.COUNTRY_OPTIONS.find(function (opt) { var _a, _b; return ((_b = (_a = item.rechCustomer) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.country) === opt.value; });
    if ((_c = (_b = item.rechCustomer) === null || _b === void 0 ? void 0 : _b.crawledMigrationCustomer) === null || _c === void 0 ? void 0 : _c.confirmedOn) {
        return (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ pl: 1.75 }, { children: (0, jsx_runtime_1.jsx)(PopupText_1.default, { message: val === null || val === void 0 ? void 0 : val.label }) }));
    }
    var handleChange = function (valObj) { return submitCustomer({ address: { country: valObj.value } }); };
    return ((0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { options: intl_1.COUNTRY_OPTIONS, label: "Select a country", placeholder: "Select a country", onChange: handleChange, noOptionsText: "Country not found", value: val !== null && val !== void 0 ? val : null, isDisabled: !item.rechCustomerId, btnProps: { withBorders: true, disabled: isSending } }));
};
exports.default = CountrySelect;
